import { inject, Injectable } from '@angular/core';

import { IndustryModel } from '~app/models/industry.model';
import { LicenseListModel } from '~app/models/responses/license-list.model';
import { UserListModel } from '~app/models/responses/user-list.model';
import { IndustriesStore } from '~app/services/stores/industries.store';
import { LicensesStore } from '~app/services/stores/licenses.store';
import { ResellersStore } from '~app/services/stores/resellers.store';
import { UsersStore } from '~app/services/stores/users.store';
import { DataSelectionDialogDataModel } from '~components/dialogs/data-selection-dialog/models/data-selection-dialog-data.model';
import { ComplexDataTypesEnum } from '~core/models/complex-data-types.enum';
import { industrySelectionTableConfig } from './industry-selection-table.config';
import { licenseSelectionTableConfig } from './license-selection-table.config';
import { userSelectionTableConfig } from './user-selection-table.config';

@Injectable({ providedIn: 'root' })
export class DialogModelFactoryService {
    private readonly licensesStore = inject(LicensesStore);
    private readonly usersStore = inject(UsersStore);
    private readonly resellersStore = inject(ResellersStore);
    private readonly industriesStore = inject(IndustriesStore);

    create(type: ComplexDataTypesEnum, isMultiSelect = false): DataSelectionDialogDataModel<any, number> {
        switch (type) {
            case ComplexDataTypesEnum.License:
                return new DataSelectionDialogDataModel<LicenseListModel, number>({
                    store: this.licensesStore,
                    columnConfig: licenseSelectionTableConfig,
                    dialogTitleKey: 'License.EntityName',
                    isMultiSelect
                });
            case ComplexDataTypesEnum.User:
                return new DataSelectionDialogDataModel<UserListModel, number>({
                    store: this.usersStore,
                    columnConfig: userSelectionTableConfig,
                    dialogTitleKey: 'User.EntityName',
                    isMultiSelect
                });
            case ComplexDataTypesEnum.Reseller:
                return new DataSelectionDialogDataModel<UserListModel, number>({
                    store: this.resellersStore,
                    columnConfig: userSelectionTableConfig,
                    dialogTitleKey: 'General.Reseller',
                    isMultiSelect
                });
            case ComplexDataTypesEnum.Industry:
                return new DataSelectionDialogDataModel<IndustryModel, number>({
                    store: this.industriesStore,
                    columnConfig: industrySelectionTableConfig,
                    dialogTitleKey: 'General.Industry',
                    isMultiSelect
                });
            default:
                throw new Error(`Unsupported ComplexDataTypesEnum: ${type}`);
        }
    }
}
